export default __webpack_public_path__ + "static/media/dangerIcon.552cdc19.svg";